import React, { FC } from 'react';
import cx from 'classnames';
// package imports
import useThemeBlock from '@/hooks/useThemeBlock';
import { Image } from '../Image/render';
// internal imports
import block from './block.json';
// styles
import { getStyles } from './styles.css';

/**
 * TYPINGS
 */
type ImageResponsiveProps = {
	imageDefault?: ImageProps;
	imageMobile?: ImageProps;
} & ThemeProps;

/**
 * COMPONENT
 */
export const ImageResponsive: FC<ImageResponsiveProps> & BlockConfigs = ({
	imageDefault,
	imageMobile,
	theme = {},
}) => {
	const { variant /*, blockTheme*/ } = useThemeBlock(block.slug, theme);

	const htmlProps = {
		'data-variant': variant,
	};

	const rootClass = cx('supt-imageResponsive', getStyles(), {
		'supt-imageResponsive--has-mobile-image': imageMobile?.src,
	});

	return (
		<div className={rootClass} data-block={block.slug} {...htmlProps}>
			{imageDefault?.src && (
				<span className="supt-imageResponsive__imageWrapper supt-imageResponsive__imageWrapper--desktop">
					<Image
						{...imageDefault}
						alt={imageDefault.alt || ''}
						className="supt-imageResponsive__image"
						layout="responsive"
					/>
				</span>
			)}

			{imageMobile?.src && (
				<span className="supt-imageResponsive__imageWrapper supt-imageResponsive__imageWrapper--mobile">
					<Image
						{...imageMobile}
						caption={imageDefault.caption}
						alt={imageMobile.alt || ''}
						className="supt-imageResponsive__image"
						layout="responsive"
					/>
				</span>
			)}
		</div>
	);
};

ImageResponsive.slug = block.slug;
ImageResponsive.title = block.title;
